function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 256 256",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M213 32l27 32h-20v128h20l-27.5 32-27.5-32h20V64h-20l28-32z",
  fill: "#000"
}), React.createElement("path", {
  d: "M32 64l1.158-7.41-8.658-1.353V64H32zm0 128h-7.5v8.628l8.544-1.201L32 192zm128-18l1.044 7.427 6.456-.908V174H160zm0-90h7.5v-6.42l-6.342-.99L160 84zM24.5 64v128h15V64h-15zm8.544 135.427l128-18-2.088-14.854-128 18 2.088 14.854zM161.158 76.59l-128-20-2.316 14.82 128 20 2.316-14.82zM167.5 174V84h-15v90h15z",
  fill: "#000"
})));